import script from "./ParcelDimensions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParcelDimensions.vue?vue&type=script&setup=true&lang=ts"

import "./ParcelDimensions.vue?vue&type=style&index=0&id=648b8cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648b8cb2"]])

export default __exports__